import { Box, SvgIconProps, Typography, useTheme } from "@mui/material";
import { ComponentType } from "react";
import { useLocation } from "react-router-dom";
import { useGuardedNavigation } from "../../hooks/use_guarded_navigation";

export const MenuItem = ({
  Icon,
  title,
  link,
  iconFillColor,
  hoverColor,
}: {
  Icon: ComponentType<SvgIconProps>;
  title: string;
  link: string;
  iconFillColor?: string;
  hoverColor?: string;
}) => {
  const theme = useTheme();
  const location = useLocation();
  const { navigateWithGuards } = useGuardedNavigation();
  const isActive =
    location.pathname.split("/")[1] === link.split("/")[1] ||
    (link === "/run-history" && location.pathname === "/");
  const isDisabled = location.pathname.includes("_preview");

  // Set default colors
  const defaultIconFillColor = iconFillColor || theme.palette.grey[600];
  const activeIconFillColor = theme.palette.grey[800];

  return (
    <Box
      onClick={() => {
        if (isDisabled) {
          return;
        }

        navigateWithGuards(link);
      }}
      sx={{
        textDecoration: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: 0.5,
        m: 1,
        backgroundColor: (theme) =>
          isActive ? theme.palette.action.hover : "transparent",
        borderRadius: "8px",
        transition: "background-color 0.3s ease",
        "&:hover": {
          backgroundColor: hoverColor || theme.palette.action.hover,
        },
        cursor: isDisabled ? "not-allowed" : "pointer",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon
          sx={{
            fill: isActive ? activeIconFillColor : defaultIconFillColor,
            transition: "fill 0.3s ease",
          }}
        />
      </Box>
      <Typography
        sx={{
          fontSize: "10px",
          color: isActive ? activeIconFillColor : defaultIconFillColor,
          transition: "color 0.3s ease",
          whiteSpace: "wrap",
          textAlign: "center",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};
